var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 259,
    viewBox: "0 0 260 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.76 258.75C201.17 258.75 259.06 200.827 259.06 129.375C259.06 57.9232 201.17 0 129.76 0C58.3496 0 0.459961 57.9232 0.459961 129.375C0.459961 200.827 58.3496 258.75 129.76 258.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.36 145.574L206.55 129.375L129.76 52.5405L52.9697 129.375L69.1597 145.574L118.31 96.396V206.21H141.21V96.396L190.36 145.574Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLarge);
export default __webpack_public_path__ + "static/media/arrowLarge.ccdd0306969423d6bc315c66c7a34f5b.svg";
export { ForwardRef as ReactComponent };